<template>
    <!-- 折叠面板组件 -->
    <div class="vel-collapse">
        <!-- 头部插槽 -->
        <slot name="header"></slot>
        <el-collapse v-model="collNames" :accordion="accordion" @change="change">
            <template v-for="coll in collList">
                <el-collapse-item :title="coll.title" :name="coll.name" :disabled="coll.disabled||false" :key="coll.name">
                    <span v-if="!coll.title" slot="title">
                        <!-- item标题插槽 -->
                        <slot name="title"></slot>
                    </span>
                    <!-- 内容插槽 -->
                    <slot :name="coll.name"></slot>
                </el-collapse-item>
            </template>
        </el-collapse>
        <!-- 底部插槽 -->
        <slot name="footer"></slot>
    </div>
</template>
<script>
export default {
    name:"VelCollapse",
    props:{
        initValue:{
            type: [String,Array]
        },
        isAccordion: Boolean,
        collList:{
            type: Array,
            required: true
        }
    },
    data() {
        return {
            collNames:null,
            accordion:true,
        };
    },
    watch:{
        initValue:{
            handler(newval){
                if(!newval) return 
                this.collNames = newval
            },
            deep:true,
            immediate:true,
        }
    },
    created() {
        // this.getValue()
        this.initDataFn()
    },
    methods: {
        initDataFn(){
            this.isAccordion ? this.accordion = false : this.accordion
        },
        getValue(){
            this.initValue ? this.collNames = this.initValue :
            this.collNames = this.collList[0].name
        },
        change(val){
            this.$emit('collChange',val)
        },
    },
}
</script>
<style >

</style>